import { HeatMapOutlined } from "@ant-design/icons";
import React, { useMemo, useState } from "react";
import CustomTag from "./CustomTag";
import GrainAnalyticsModuleDTO from "src/models/GrainAnalyticsModuleDTO";
import { formatNumber } from "src/utils/formatting";

interface CO2StatusTagProps {

    gaMs: GrainAnalyticsModuleDTO[] | null | undefined;
}

const CO2StatusTag : React.FC<CO2StatusTagProps> = ({ gaMs }) => {

    const ppm = useMemo (() => {
        const innerCo2 = gaMs?.sort((a, b) => a.radiusFt - b.radiusFt)[0]?.co2Ppm;
        const outerCo2 = gaMs?.sort((a, b) => b.radiusFt - a.radiusFt)[0]?.co2Ppm;

        if (innerCo2 == null && outerCo2 == null) return null;
        if (innerCo2 == null) return outerCo2;
        if (outerCo2 == null) return innerCo2;

        return (innerCo2 + outerCo2) / 2;
    }, [gaMs]);
    const co2Formatted = formatNumber(ppm, {decimalPlaces: 0, filler: 'ERROR', suffix: "ppm"});

    
    if(ppm == null){
        return <CustomTag label={`CO2: ${co2Formatted}`} color='red' icon={<HeatMapOutlined />}/>
    }

    if(ppm < 600){
        return <CustomTag label={`CO2: ${co2Formatted}`} color='green' icon={<HeatMapOutlined/>}/>
    }
    
    if(ppm < 1201){
        return <CustomTag label={`CO2: ${co2Formatted}`} color='orange' icon={<HeatMapOutlined/>}/>
    }

    return <CustomTag label={`CO2: ${co2Formatted}`} color='red' icon={<HeatMapOutlined/>}/>
}

export default CO2StatusTag;